$(function () {
	$.nette.init();

	$(document).on('click', '.menu-toggle', function () {
		$('#main-nav-mobile').toggleClass('open');
	});

	$('a[href^="#"]').on('click',function (e) {
		e.preventDefault();
		slide(this.hash);
	});
	if (location.hash)
		slide(location.hash);

	function slide(target) {
		$('html, body').stop().animate({
			scrollTop: $(target).offset().top - $('#masthead').outerHeight()
		}, 500);
	}

	//let htmlElement = document.getElementsByName('html');
	//console.log(htmlElement);


});

//var prevScrollpos = window.pageYOffset;
//menuToggle();
//window.onscroll = function () {
//	menuToggle();
//};
//function menuToggle() {
//	var currentScrollPos = window.pageYOffset;
//	if (currentScrollPos > 220)
//	{
//		if (prevScrollpos > currentScrollPos) {
//			document.getElementById("masthead").style.top = "0";
//		} else {
//			document.getElementById("masthead").style.top = "-110px";
//		}
//	}
//	prevScrollpos = currentScrollPos;
//}

$('html').removeClass('no-js');